const MultiSelectContainerStyle = `
  grid-auto-flow: row;
`;

export default MultiSelectContainerStyle;
